module.exports = __webpack_public_path__ + "img/尺度.7a62a37.png";